import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Service } from '../../models/service.model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class ServiceService {

  private baseUrl = HttpClientService.BASE_MS_COMMON;
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private srvNotify: MessageService
  ) { }

  get(id: number): Observable<Service> {
    return this.h.get(this.baseUrl + '/service/services/' + id)
      .map(res => {
        return res;
      });
  }

  getAll(): Observable<Service[]> {
    return this.h.get(this.baseUrl + '/service/services')
      .map(res => {
        return res;
      });
  }

  delete(record) {
    return this.h.delete(this.baseUrl + '/service/services/' + record.id)
      .map(res => {
        this.srvNotify.add({severity: 'success', summary: 'Confirmed', detail: 'Service deleted'});
      });
  }

  post(newData) {
    return this.h.post(this.baseUrl + '/service/services/', newData)
      .map(res => {
        newData.id = res.id;
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(newData) {
    return this.h.put(this.baseUrl + '/service/services/' + newData.id, newData)
      .map(res => {
        this.srvNotify.add({severity: 'success', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/ServiceDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/service/service.service.ts